// extracted by mini-css-extract-plugin
export var active = "_1l-d";
export var blink = "_1l-e";
export var container = "_1l-5";
export var controls = "_1l-0";
export var controlsRight = "_1l-1";
export var fakeCursor = "_1l-c";
export var hidden = "_1l-b";
export var quillContainerSmall = "_1l-7";
export var quillEditor = "_1l-6";
export var quillEditorSmall = "_1l-8";
export var quillFormatButtons = "_1l-a";
export var quillToolbar = "_1l-9";
export var removePadding = "_1l-2";
export var state = "_1l-3";
export var stateTitle = "_1l-4";